import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import axios from 'axios';
import Modal from 'react-modal';
import AgentsOverlay from '../../charts/card/AgentsOverlay/AgentsOverlay';
import { useSelector, useDispatch } from 'react-redux';
import TableComponent from '../table/TableComponent';
import { agentSlice } from '../../../redux/reducers';

const Agent = ({ data }) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [resp, setResp] = useState();
    const [slicedData, setSlicedData] = useState([]);
    const dispatch = useDispatch();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const apiAgentsDrilldownURL = `${baseUrl}/api/dashboard/collections/charts/agents/products`
    const selectedFilterValues = useSelector(state => state.filterValues.filterValues);
    const collectFilterList = useSelector(state => state.filter.data);
    // console.log("=+==+====+++==++> collect filter list",collectFilterList);
    const agentsUrl = `${baseUrl}/api/dashboard/collections/charts/agents`;
    // console.log("filter data inside agents",selectedFilterValues);
    useEffect(() => {
        if (data && data.length) {
            setSlicedData(data.slice(0, 6));
        }
    }, [data]);

    useEffect(() => {
        fetchAgents(filterData);
    }, [selectedFilterValues]);

    useEffect(() => {
        if (modalIsOpen) {
            const fetchDrilldownAgentsData = async () => {
                try {

                    let payload = {

                        "filter": []
                    }

                    if (selectedFilterValues.to !== "" &&
                        selectedFilterValues.from !== "" && selectedFilterValues.PRODUCT !== "") {

                        payload.filter = [
                            {
                                "id": "ACTION_HISTORY.ACTION_TAKEN_ON",
                                "datatype": "DATE",
                                "value": {
                                    "from": `${selectedFilterValues.from}`,
                                    "to": `${selectedFilterValues.to}`
                                }
                            },
                            {
                                "id": "ACCOUNTS.PRODUCT_CODE",
                                "value": `${selectedFilterValues.PRODUCT}`
                            }

                        ]
                    }
                    const response = await axios.post(apiAgentsDrilldownURL, payload);
                    // console.log("============> drilldown agents", response.data.data);
                    setResp(response.data.data);

                } catch (error) {
                    console.error(error);
                }
            }
            fetchDrilldownAgentsData();
        }

    }, [selectedFilterValues, modalIsOpen]);

    // useEffect(() => {
    //     console.log("=================> drilldown resp", resp);
    // }, [resp])

    const openModal = () => {
        setModalIsOpen(true);
    }

    const closeModal = () => {
        setModalIsOpen(false)
    }
    console.log("selected filter values inside agent", selectedFilterValues);
    // const filterData = Object.keys(selectedFilterValues)?.map(key => {
    const filterData = Object.keys(selectedFilterValues ?? {})?.map(key => {
        // console.log("object keys =====>", Object.keys(selectedFilterValues));
        const filterConfig = Array.isArray(collectFilterList) ? collectFilterList.find(ele => ele?.FILTER_ID === key) : [];
        console.log("filter cofign =======>", filterConfig);
        if (key === 'from' || key === 'to') {
            const dateFilterData = Array.isArray(collectFilterList) ? collectFilterList?.find(ele => ele?.DISPLAY_TYPE === 'DATE_PICKER') : [];
            if (dateFilterData) {
                return {
                    id: `${dateFilterData.BASE_TABLE}.${dateFilterData.BASE_COLUMN}`,
                    datatype: 'DATE',
                    value: {
                        from: selectedFilterValues.from,
                        to: selectedFilterValues.to
                    }
                }
            }
        } else if (filterConfig) {
            const filterValues = Array.isArray(selectedFilterValues[key])
                ? selectedFilterValues[key] : [selectedFilterValues[key]];
            console.log("filter values ====-=-=-=-=>",filterValues);
            return filterValues?.map(value => ({
                id: `${filterConfig.BASE_TABLE}.${filterConfig.BASE_COLUMN}`,
                value
            }))
        }
        return null;
    }).flat().filter(Boolean);
    console.log("filter data =====>", filterData);
    const fetchAgents = async (filterData = [], sort = []) => {
        try {
            //   const applicationDetailsAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/applications-details`;
            const payload = {
                filter: filterData?.length > 0 ? filterData : [],
                sort: sort?.length > 0 ? sort : []
            }
            console.log("payload in agents.js =========================>", payload);
            const response = await axios.post(agentsUrl, payload);
            dispatch(agentSlice?.actions?.agentReducer(response?.data?.data));
            //   setApplicationDetails(response?.data?.data);
        } catch (error) {
            console.log(error);
        }
    }

    const handleSort = async (column, order) => {
        const sortParams = [{ id: column, value: order }];
        fetchAgents(filterData, sortParams);
    }

    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Agents Table Modal"
                className="modal"
                style={{
                    overlay: {
                        backgroundColor: 'rgba(45, 45, 45, 0.8)',
                    },
                }}
            >
                <AgentsOverlay data={data} response={resp} />
            </Modal>
            <div className="agent_container">
                <div id='agent_header'>
                    <h3>Agents</h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none" onClick={openModal} >
                        <path d="M21.7092 12.5384L15.8723 5.78401C15.4704 5.31889 14.8198 5.31889 14.437 5.78401C14.0351 6.24914 14.0351 7.00207 14.437 7.44487L18.5516 12.2062L4.84925 12.2062C4.29431 12.2062 3.83492 12.7378 3.83492 13.3799C3.83492 14.0221 4.29431 14.5537 4.84925 14.5537L18.5324 14.5537L14.437 19.3149C14.0351 19.7801 14.0351 20.533 14.437 20.9759C14.6285 21.1974 14.8964 21.3302 15.1643 21.3302C15.4322 21.3302 15.681 21.2195 15.8915 20.9759L21.7476 14.1993C21.939 13.9778 22.0538 13.6678 22.0538 13.3578C22.0155 13.07 21.9007 12.76 21.7092 12.5384Z" fill="#D9D9D9" />
                    </svg>
                </div>
                <TableComponent tableData={slicedData} onSort={handleSort} />
            </div>
        </>
    );
};

Agent.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            collectedAmount: PropTypes.string.isRequired,
            workedAccounts: PropTypes.number.isRequired,
            actionsTaken: PropTypes.string.isRequired
        })
    ).isRequired
}

export default Agent;
